// extracted by mini-css-extract-plugin
export var social_links_container = "footer-module--social_links_container--2pGqb";
export var social_icons_container = "footer-module--social_icons_container--1yr4c";
export var links_container = "footer-module--links_container--frQ5c";
export var disclaimer_container = "footer-module--disclaimer_container--1KHqj";